import { api } from './http';

export const relogio = ofertaCompraId => api.get(`/ofertascompra/${ofertaCompraId}/relogio`);
export const stats = type => api.get(`/ofertascompra/stats?type=${type}`);

export const get = ofertaCompraId => api.get(`/ofertascompra/${ofertaCompraId}`);
export const criar = tipo => api.post('/ofertascompra', { tipo });
export const editAuction = (auctionId, data) => api.patch(`/ofertascompra/${auctionId}`, data);
export const encerrarAnalise = ofertaCompraId =>
  api.patch(`ofertascompra/${ofertaCompraId}/encerrar-analise`);
export const encerrarLances = ofertaCompraId =>
  api.patch(`ofertascompra/${ofertaCompraId}/encerrar-etapa-lances`);
export const encerrarHabilitacao = ofertaCompraId =>
  api.post(`/auctions/${ofertaCompraId}/encerrar-habilitacao`);
export const encerrarJulgamento = ofertaCompraId =>
  api.post(`/auctions/${ofertaCompraId}/encerrar-julgamento`);
export const encerrarInterposicaoDeRecursos = ofertaCompraId =>
  api.patch(`auctions/${ofertaCompraId}/encerrar-interposicao-recursos`);
export const voltarParaAnaliseDePropostas = ofertaCompraId =>
  api.patch(`ofertascompra/${ofertaCompraId}/voltar-para-analise`);
export const obterOpcoesVoltarEtapa = ofertaCompraId =>
  api.get(`ofertascompra/${ofertaCompraId}/voltar-etapa/opcoes`);
export const voltarEtapa = (ofertaCompraId, data) =>
  api.patch(`ofertascompra/${ofertaCompraId}/voltar-etapa`, data);
export const reabrirSessao = ofertaCompraId =>
  api.patch(`/ofertascompra/${ofertaCompraId}/reabrir`);
export const encerrarOferta = ofertaCompraId =>
  api.patch(`ofertascompra/${ofertaCompraId}/encerrar-sessao`);
export const deletar = ofertaCompraId => api.delete(`/ofertascompra/${ofertaCompraId}`);

export const getResponsaveis = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/responsaveis`);
export const criarResponsavel = (ofertaCompraId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/responsaveis`, dados);
export const deletarResponsavel = (ofertaCompraId, responsavelId) =>
  api.delete(`/ofertascompra/${ofertaCompraId}/responsaveis/${responsavelId}`);
export const alterarPregoeiro = (ofertaCompraId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/pregoeiro`, dados);
export const changeCrier = (auctionId, userId) =>
  api.post(`/ofertascompra/${auctionId}/responsibles/change-crier`, { userId });

export const getPrazos = ofertaCompraId => api.get(`/ofertascompra/${ofertaCompraId}/prazos`);

export const getItens = (ofertaCompraId, listarItensLote = false, v2 = false) => {
  const params = `?listarItensLote=${listarItensLote}&v2=${v2}`;
  return api.get(`/ofertascompra/${ofertaCompraId}/itens${params}`);
};

export const getItem = (ofertaCompraId, itemId) =>
  api.get(`/ofertascompra/${ofertaCompraId}/itens/${itemId}`);

export const getBatchItens = itemId => api.get(`/ofertascompra/${itemId}/itens/lote`);

export const atualizarItem = (ofertaCompraId, itemId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/itens/${itemId}`, dados);

export const revogarItem = (ofertaCompraId, itemId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/itens/${itemId}/revogar`, dados);
export const deletarItem = (ofertaCompraId, ofertaCompraItemId) =>
  api.delete(`/ofertascompra/${ofertaCompraId}/itens/${ofertaCompraItemId}`);
export const deletarLoteItem = (ofertaCompraId, ofertaCompraItemId, ofertaCompraItemLoteId) => {
  return api.delete(
    `/ofertascompra/${ofertaCompraId}/itens/${ofertaCompraItemId}/itens-lote/${ofertaCompraItemLoteId}`,
  );
};

export const publishAuction = auctionId => api.get(`/ofertascompra/${auctionId}/publicar`);
export const openAuctionSession = auctionId => api.get(`/ofertascompra/${auctionId}/abrir-sessao`);

export const getLances = (ofertaCompraId, tipo) =>
  api.get(`/ofertascompra/${ofertaCompraId}/lances/?filtro=${tipo}`);
export const getLancesItem = (ofertaCompraId, itemId) =>
  api.get(`/ofertascompra/${ofertaCompraId}/itens/${itemId}/lances`);
export const getOfertasItem = (ofertaCompraId, itemId) =>
  api.get(`/ofertascompra/${ofertaCompraId}/itens/${itemId}/ofertas`);
export const iniciarLance = (ofertaCompraId, lances) =>
  api.post(`/ofertascompra/${ofertaCompraId}/itens/lances`, lances);
export const enviarLance = (ofertaCompraId, lances) =>
  api.post(`/ofertascompra/${ofertaCompraId}/lances`, lances);
export const getElegiveisFechado = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/elegiveis-fechado`);
export const getParticipantesFechado = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/participantes-fechado`);

export const iniciarPreferencia = (ofertaCompraId, itens) =>
  api.post(`/ofertascompra/${ofertaCompraId}/itens/iniciar/preferencia`, itens);
export const enviarPreferencia = (ofertaCompraId, preferencias) =>
  api.post(`/ofertascompra/${ofertaCompraId}/preferencias`, preferencias);

export const getAnexos = ofertaCompraId => api.get(`/ofertascompra/${ofertaCompraId}/anexos`);
export const getAtasPrecosEligibility = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/arp/eligibility`);
export const getAtasPrecosFornecedores = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/arp/fornecedores`);
export const getAtasPrecosItens = (ofertaCompraId, params = {}) =>
  api.get(`/ofertascompra/${ofertaCompraId}/arp/itens`, { params });
export const getAtasPrecos = ofertaCompraId => api.get(`/ofertascompra/${ofertaCompraId}/arp`);
export const gerarAtaPreco = (ofertaCompraId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/arp/gerar`, dados);
export const atualizarAtaPrecoRascunho = (ofertaCompraId, ataId, dados) =>
  api.put(`/ofertascompra/${ofertaCompraId}/arp/${ataId}/rascunho`, dados);
export const criarAtaPreco = (
  ofertaCompraId,
  dados,
  { onUploadProgress } = { onUploadProgress: () => {} },
) => api.post(`/ofertascompra/${ofertaCompraId}/arp`, dados, { onUploadProgress });
export const publicarAtaPreco = (
  ofertaCompraId,
  ataId,
  dados,
  { onUploadProgress } = { onUploadProgress: () => {} },
) =>
  api.post(`/ofertascompra/${ofertaCompraId}/arp/${ataId}/publicar`, dados, {
    onUploadProgress,
  });
export const retificarAtaPreco = (ofertaCompraId, ataId, dados) =>
  api.put(`/ofertascompra/${ofertaCompraId}/arp/${ataId}`, dados);
export const deletarAtaPreco = (ofertaCompraId, ataId, body) =>
  api.delete(`/ofertascompra/${ofertaCompraId}/arp/${ataId}`, body ? { data: body } : {});
export const criarAtaPrecoDocumento = (ofertaCompraId, ataId, dados, { onUploadProgress } = {}) =>
  api.post(`/ofertascompra/${ofertaCompraId}/arp/${ataId}/documentos`, dados, {
    onUploadProgress,
  });
export const deletarAtaPrecoDocumento = (ofertaCompraId, ataId, documentoId, body) =>
  api.delete(
    `/ofertascompra/${ofertaCompraId}/arp/${ataId}/documentos/${documentoId}`,
    body ? { data: body } : {},
  );
export const consultarAtaPrecoParteEnvolvidaPncpUnidades = (ofertaCompraId, cnpj) =>
  api.get(`/ofertascompra/${ofertaCompraId}/arp/partes-envolvidas/pncp-unidades`, {
    params: { cnpj },
  });
export const criarAtaPrecoParteEnvolvida = (ofertaCompraId, ataId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/arp/${ataId}/partes-envolvidas`, dados);
export const deletarAtaPrecoParteEnvolvida = (ofertaCompraId, ataId, parteId, body) =>
  api.delete(
    `/ofertascompra/${ofertaCompraId}/arp/${ataId}/partes-envolvidas/${parteId}`,
    body ? { data: body } : {},
  );
export const criarAnexos = (
  ofertaCompraId,
  dados,
  { onUploadProgress } = { onUploadProgress: () => {} },
) => api.post(`/ofertascompra/${ofertaCompraId}/anexos`, dados, { onUploadProgress });
export const deletarAnexo = (ofertaCompraId, id) =>
  api.delete(`/ofertascompra/${ofertaCompraId}/anexos/${id}`);

export const aceitarLanceNegociacao = (ofertaCompraId, itemId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/negociacao/${itemId}/aceitar/`, dados);
export const enviarLanceNegociacao = (ofertaCompraId, propostas) =>
  api.post(`/ofertascompra/${ofertaCompraId}/negociacao/enviar/`, propostas);
export const recusarLanceNegociacao = (ofertaCompraId, itemId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/negociacao/${itemId}/recusar/`, dados);

export const fetchChatMessages = auctionId => api.get(`/ofertasCompra/${auctionId}/chat`);
export const fetchChatParticipants = auctionId =>
  api.get(`/ofertasCompra/${auctionId}/participants`);
export const fetchChatPermissions = auctionId =>
  api.get(`/ofertasCompra/${auctionId}/chat/permission`);
export const changeChatMode = (auctionId, mode) =>
  api.patch(`/ofertasCompra/${auctionId}/chat/mode`, { mode });
export const setBidderChatBlock = (auctionId, bidderId, block) =>
  api.patch(`/ofertasCompra/${auctionId}/chat/bidders/${bidderId}`, { block });

export const getRecursos = ofertaCompraId => api.get(`/ofertascompra/${ofertaCompraId}/recursos`);
export const getIntencaoRecurso = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/recursos/intencao`);
export const getElegibilidadeRazoes = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/recursos/elegibilidade`);
export const manifestarIntencaoRecurso = ofertaCompraId =>
  api.post(`/ofertascompra/${ofertaCompraId}/recursos/intencao`, {});
export const criarRecurso = (ofertaCompraId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/recursos`, dados);
export const atualizarRazoesRecurso = (ofertaCompraId, recursoId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/recursos/${recursoId}/razoes`, dados);
export const criarContrarrazao = (ofertaCompraId, recursoId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/recursos/${recursoId}/contrarrazoes`, dados);
export const atualizarContrarrazaoRecurso = (ofertaCompraId, recursoId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/recursos/${recursoId}/contrarrazoes`, dados);
export const excluirRazoesRecurso = (ofertaCompraId, recursoId, body) =>
  api.delete(
    `/ofertascompra/${ofertaCompraId}/recursos/${recursoId}/razoes`,
    body ? { data: body } : {},
  );
export const excluirContrarrazaoRecurso = (ofertaCompraId, recursoId, body) =>
  api.delete(
    `/ofertascompra/${ofertaCompraId}/recursos/${recursoId}/contrarrazoes`,
    body ? { data: body } : {},
  );
export const atualizarRecurso = (ofertaCompraId, recursoId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/recursos/${recursoId}`, dados);
export const julgamentoAutoridadeRecurso = (ofertaCompraId, recursoId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/recursos/${recursoId}/julgamento-autoridade`, dados);
export const getPrazosRecursais = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/prazos-recursais`);
export const definirPrazosRecursais = (ofertaCompraId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/prazos-recursais`, dados);
export const ajustarPrazosRecursais = (ofertaCompraId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/prazos-recursais`, dados);
export const encerrarPrazoRecursal = (ofertaCompraId, dados = {}) =>
  api.post(`/ofertascompra/${ofertaCompraId}/prazos-recursais/encerrar`, dados);

export const getPrazosManifestacaoIntencao = ofertaCompraId =>
  api.get(`/ofertascompra/${ofertaCompraId}/prazos-manifestacao-intencao`);
export const definirPrazosManifestacaoIntencao = (ofertaCompraId, dados) =>
  api.post(`/ofertascompra/${ofertaCompraId}/prazos-manifestacao-intencao`, dados);
export const ajustarPrazosManifestacaoIntencao = (ofertaCompraId, dados) =>
  api.patch(`/ofertascompra/${ofertaCompraId}/prazos-manifestacao-intencao`, dados);
export const encerrarPrazoManifestacaoIntencao = (ofertaCompraId, dados = {}) =>
  api.post(`/ofertascompra/${ofertaCompraId}/prazos-manifestacao-intencao/encerrar`, dados);

export const exportAccountIntegration = ofertaCompraId =>
  api.get(`/auctions/${ofertaCompraId}/accounting-integration`);

export const exportPublicenterIntegration = ofertaCompraId =>
  api.get(`/auctions/${ofertaCompraId}/publicenter-integration`);

export const buscarOfertaAdesaoEmpresas = ofertaCompraId =>
  api.get(`/ofertasCompra/${ofertaCompraId}/adesao-empresas`);

export const adjudicarVencedorItens = (ofertaCompraId, data) =>
  api.post(`/auctions/${ofertaCompraId}/items/adjudication`, data);

export const homologarVencedorItens = (ofertaCompraId, data) =>
  api.post(`/auctions/${ofertaCompraId}/items/homologation`, data);

export const deletarProposta = (ofertaCompraId, itemId, proposalId) =>
  api.delete(`/auctions/${ofertaCompraId}/items/${itemId}/proposals/${proposalId}`);

export const deletarLance = (ofertaCompraId, itemId, lanceId) =>
  api.delete(`/auctions/${ofertaCompraId}/items/${itemId}/bids/${lanceId}`);

export const excluirUltimoLance = item =>
  api.delete(`/auctions/${item.ofertaCompraId}/items/${item.itemId}/last-bid`);

export const generateAuctionMinutes = (auctionId, data) =>
  api.patch(`/ofertascompra/${auctionId}/gerar-ata`, data);

export const previewUndoAuctionItems = (ofertaCompraId, itemIds, targets) =>
  api.get(`/ofertascompra/${ofertaCompraId}/itens/desfazer`, {
    params: {
      itemIds: itemIds.join(','),
      ...(targets?.length ? { targets: JSON.stringify(targets) } : {}),
    },
  });

export const undoAuctionItems = (ofertaCompraId, { itemIds, justificativa, targets }) =>
  api.post(`/ofertascompra/${ofertaCompraId}/itens/desfazer`, {
    itemIds,
    justificativa,
    ...(targets?.length ? { targets } : {}),
  });
